module.exports = __webpack_public_path__ + "img/forever-bg-gray.36740ede.svg";